import { gql } from '@apollo/client';

export const EXPORT_TEST_PERFORMANCE = gql`
  query ExportTestPerformance($input: ExportArgs!) {
    exportTestPerformance(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      testPerformanceData {
        id
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        grade {
          id
          value
        }
        averageMark
        level1
        level2
        level3
        level4
        level5
        level6
        level7
        numberAbsent
        numberEnrolled
        numberWrote
        passRate
        possibleAttendance
        subject {
          id
          name
        }
        term
        year
        institution {
          id
          emisNumber
          name
        }
        year
      }
    }
  }
`;
